import { useI18n } from 'vue-i18n';
import { useWalletsStore } from '~/stores/wallets/wallets-store';
import useWalletsApi from '~/composables/api/useWalletsApi';
import { useApiErrorSnackbar } from '~/composables/common/useApiErrorSnackbar';

export const useSupportWindowUtils = () => {
  const { locale } = useI18n();
  const { getWallet } = useWalletsApi();
  const { userInfos } = storeToRefs(useWalletsStore());
  const { notifyApiError } = useApiErrorSnackbar();
  const login = localStorage.getItem('username') || '';

  const getUserInfos = async (walletIntId: number) => {
    try {
      const walletData = await getWallet(walletIntId);
      userInfos.value = walletData.Wallet;
    } catch (error: unknown) {
      notifyApiError(error);
    }
  };

  const openSupportWindow = (
    subject: string,
    category: string,
    externalId: string,
    i18n: string
  ) => {
    const parameters = {
      tf_anonymous_requester_email: login,
      tf_subject: subject,
      tf_44634345: category,
      tf_7564983415965: externalId,
      tf_7564256084125: window.location.href
    };
    const language = i18n === 'fr' ? 'fr' : 'en-us';
    const path = `https://support.lemonway.com/hc/${language}/requests/new?`;
    const queryString = Object.entries(parameters)
      .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
      .join('&');

    const newWindow = window.open(path + queryString, '_blank', 'noopener,noreferrer');
    if (!newWindow) {
      // Handle error
    }
  };

  const openSupportWindowHandler = async (
    subject: string,
    category: string,
    externalId: string,
    walletIntId: number
  ) => {
    if (userInfos.value.intId === undefined || userInfos.value.intId !== walletIntId) {
      await getUserInfos(walletIntId);
    }

    openSupportWindow(subject, category, externalId, locale.value);
  };

  return {
    getUserInfos,
    openSupportWindow,
    openSupportWindowHandler
  };
};
